import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silence benign ResizeObserver loop warnings (Radix Select/Dialog trigger these)
const swallow = (e) => {
  if (e && (e.message || "").includes("ResizeObserver")) {
    e.stopImmediatePropagation();
  }
};
window.addEventListener("error", swallow);
window.addEventListener("unhandledrejection", swallow);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
